import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useChatbotStore, useUserStore, useUtmStore, useChatStateStore } from "../../zustand/store";
import { useChatbot } from "../../services/queries/chatbotQueries";
import { handleErrorRedirect } from "../../utils/errorCodeHandler";
import { LayoutModeEnum } from "../../type/modeState.type";

const Transaction = () => {
    const navigate = useNavigate();
    const queryString = window.location.search;
    const [searchParams, setSearchParams] = new useSearchParams(queryString);
    const partnerType = useParams().partnerType;
    const partnerId = searchParams.get('ptid');
    const chatUserId = searchParams.get('cuid') || parseInt(Math.random()*1e9);
    const displayLocation = searchParams.get('dp');
    const displayItemId = searchParams.get('it');
    const isConsole = searchParams.get('isConsole') === 'true';
    const isBuilder = searchParams.get('isBuilder');
    const layoutMode = searchParams.get('mode');
    const testVariant = searchParams.get('variant');    // A/B test variant : for FlowLift project
    const nullLang = searchParams.get('lang') === 'null' || searchParams.get('lang') === null;
    const language = nullLang ? partnerType === 'shopify' ? 'en' : 'ko' : searchParams.get('lang');
    const utm = {
        source: searchParams.get('utms'),
        medium: searchParams.get('utmm'), 
        campaign: searchParams.get('utmca'),
        content: searchParams.get('utmco'),
        term: searchParams.get('utmt'),
        transitionPage: searchParams.get('tp'),
    };
    // const isFF = false;
    const isFF = (partnerId === '6756ad3d3aaf5b928eec329b') 
        || (partnerId ==='67615284c5ff44110dbc6613')
        || (partnerId === '67516ecf103e7e29c75a621e');

    const { setPartnerId, setPartnerType, setChatUserId } = useUserStore();
    const { setChatbot } = useChatbotStore();
    const { 
        setIsConsole, 
        setDisplayLocation, 
        setDisplayItemId, 
        setLanguage, 
        setLayoutMode,
        setAddToCartWithOption
    } = useChatStateStore();
    const { setUtmParams } = useUtmStore();
    const { data: chatbot, isLoading, error } = useChatbot(partnerId);

    useEffect(() => {
        setPartnerId(partnerId);
        setPartnerType(isFF ? 'fastfive' : partnerType);
        setChatUserId(chatUserId);
        setDisplayLocation(displayLocation);
        setDisplayItemId(displayItemId);
        setIsConsole(isConsole);
        setUtmParams(utm);
        setLanguage(language);
        setLayoutMode(layoutMode === LayoutModeEnum.MODAL ? LayoutModeEnum.MODAL : LayoutModeEnum.DEFAULT);
        setAddToCartWithOption(testVariant === 'variantC' ? true : false);
        if (chatbot && !isLoading) {
            setChatbot(chatbot);
            let chatUrl;
            if (partnerType === 'dlst') {
                chatUrl = `/dlst/${chatUserId}`; 
            } else {
                chatUrl = `/chat/${chatbot.chatbotId}/${chatUserId}`;
            }
            navigate(chatUrl, { replace: true });
        }
    }, [chatbot])

    // Handle errors from useChatbot hook
    useEffect(() => {
        if (error) {
            handleErrorRedirect(error);
        }
    }, [error])
}

export default Transaction;